
import PrinterSlash from "../../../assets/filled/PrinterSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PrinterSlashIcon({ className, dataTestid = "PrinterSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PrinterSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
